
import Vue, { VNode } from 'vue';
import { Guid } from 'guid-typescript';
import { IPortfolioWindow, IVueWindow } from '@/types/Interface';
import { WindowState } from '@/types/Enum';

import WindowCustom from '@/components/desktop/Window.vue';
import WindowProperties from '@/components/desktop/WindowProperties.vue';
import APortfolioWindow from '@/components/desktop/APortfolioWindow';


function createWindow(title: string, Component: Vue) : IPortfolioWindow {
  const id: Guid = Guid.create();

  const instance: APortfolioWindow = new WindowCustom({
    propsData: { title, id },
  });
  instance.$mount(); // pass nothing
  const data: IPortfolioWindow = {
    id,
    instance,
    title,
    state: WindowState.OPENED,
  };
  return data;
}


function createWindowProps(title: string) : IPortfolioWindow {
  const id: Guid = Guid.create();

  const instance: APortfolioWindow = new WindowProperties({
    propsData: { title, id },
  });
  instance.$mount(); // pass nothing
  const data: IPortfolioWindow = {
    id,
    instance,
    title,
    state: WindowState.OPENED,
  };
  return data;
}


export {
  createWindow,
  createWindowProps,
};
